const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(batchAdjustment => ({
    ...batchAdjustment,
    account: `${batchAdjustment.account}`,
    multiplier: isNaN(parseFloat(batchAdjustment.multiplier)) ? undefined : batchAdjustment.multiplier, // eslint-disable-line no-undefined
    amount: isNaN(parseFloat(batchAdjustment.amount)) ? undefined : batchAdjustment.amount, // eslint-disable-line no-undefined
    tagDescription: !batchAdjustment.tagDescription ? undefined : `${batchAdjustment.tagDescription}`, // eslint-disable-line no-undefined
    description: !batchAdjustment.description ? undefined : `${batchAdjustment.description}`, // eslint-disable-line no-undefined
  }));

export default fixDataTypes;
